import { useTheme } from '@emotion/react';
import { Box, Divider, Grid, Link, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import RebookersLockup from 'src/assets/png/rebook-lockup-cropped.png';
import RebookersMain from 'src/assets/png/rebookers-header-image.png';
import RebookersHos from 'src/features/rebooking/assets/small-refer.png';

import { getTheme } from '../../../../utils/get-theme';
import RebookingKeepItHos from '../../assets/hos_rebooking_2728_white.png';

export const RebookingInfo: FC<{
    isPromotionalOffer?: boolean;
}> = ({ isPromotionalOffer = false }) => {
    const { t } = useTranslation();
    const { palette, spacing, breakpoints } = useTheme();
    const { isHosTheme } = getTheme();

    const rebookingDetailsLinkVS = isPromotionalOffer
        ? 'https://www.vitastudent.com/en/rebookers-discount/'
        : 'https://www.vitastudent.com/en/rebookers';

    const rebookingDetailsLink = isHosTheme
        ? 'https://houseofsocial.com/rebookers/'
        : rebookingDetailsLinkVS;

    const gradient = `linear-gradient(90deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0) 100%), url(${RebookersMain})`;
    const hosGradient = `linear-gradient(90deg, rgba(40, 40, 40, 1) 0%, rgba(40, 40, 40, 0) 40%, rgba(40, 40, 40, 0) 100%), url(${RebookersHos})`;

    return (
        <Grid
            container
            alignItems="stretch"
            bgcolor={isHosTheme ? palette.grey[900] : 'black'}
            justifyContent="space-between"
        >
            <Grid
                item
                xs={12}
                lg={6}
                p={{ xs: 4, lg: 8 }}
                bgcolor={isHosTheme ? palette.grey[900] : 'black'}
            >
                <Box css={{ gridTemplateRows: '2fr 1fr' }} width={{ xs: '100%', lg: '60%' }}>
                    <Box pb={4}>
                        <img
                            alt="Rebookers Info"
                            src={isHosTheme ? RebookingKeepItHos : RebookersLockup}
                            css={{
                                marginBottom: spacing(2),
                                ...(isHosTheme && { marginLeft: spacing(-3) }),
                                [breakpoints.down('lg')]: {
                                    width: '50%',
                                },
                            }}
                        />
                        <Typography color={palette.grey[100]}>
                            {t('rebooking_info_card_enticement')}
                        </Typography>
                    </Box>
                </Box>
                <Divider sx={{ mb: 4 }} />
                <Box gridTemplateColumns={{ xs: '1fr' }} rowGap={2} display="grid">
                    <Box
                        pr={2}
                        mr={2}
                        css={{
                            [breakpoints.down('lg')]: {
                                borderColor: 'transparent',
                            },
                        }}
                    >
                        <Stack>
                            <Typography variant="h2" color={palette.primary.main} mb={1}>
                                {isPromotionalOffer
                                    ? t('rebooking_info_card_info_01_promotion')
                                    : t('rebooking_info_card_info_01')}
                            </Typography>
                            <Typography color="white">
                                {isPromotionalOffer
                                    ? t('rebooking_info_card_info_01_detail_promotion')
                                    : t('rebooking_info_card_info_01_detail')}
                            </Typography>
                        </Stack>
                    </Box>
                </Box>
                <Grid item xs={12} pt={8}>
                    <Link href={rebookingDetailsLink} color={palette.grey[50]}>
                        <Typography fontWeight={700}>
                            {t('rebooking_info_page-additional_info_divider_link')}
                        </Typography>
                    </Link>
                </Grid>
            </Grid>
            <Grid
                alignSelf="stretch"
                item
                lg={6}
                width="100%"
                flexGrow={1}
                display={{
                    xs: 'none',
                    lg: 'inherit',
                }}
                css={{
                    backgroundImage: isHosTheme ? hosGradient : gradient,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                }}
            />
        </Grid>
    );
};
